/**
 * Formats a price value according to German currency conventions
 * - For whole numbers: adds thousands separators and ".-" suffix (e.g., "1.500.-")
 * - For decimals: shows with comma separator and 2 decimal places (e.g., "1.234,56")
 *
 * @param price - The price value (number or string)
 * @returns Formatted price string
 */
export function formatGermanPrice(price: number | string): string {
    const numPrice = parseFloat(String(price));

    if (isNaN(numPrice)) {
        return '0.-';
    }

    if (numPrice % 1 === 0) {
        return numPrice.toLocaleString('de-DE') + ',-';
    } else {
        return numPrice.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}

export function formatSliderPrice(price: number | string): string {
    const numPrice = parseFloat(String(price));

    if (isNaN(numPrice)) {
        return '0';
    }

    if (numPrice % 1 === 0) {
        return numPrice.toLocaleString('de-DE');
    } else {
        return numPrice.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}
